var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopRightGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 299,
    viewBox: "0 0 300 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.663 92.6534C189.624 95.5906 193.296 109.293 185.271 117.317L98.812 203.776C90.7876 211.801 77.0855 208.129 74.1481 197.168L42.5019 79.0623C39.5647 68.1007 49.5953 58.0701 60.5572 61.0072L178.663 92.6534Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225.55 182.568L65.9971 225.32C54.3089 228.451 47.3726 240.465 50.5045 252.154L50.5045 252.154C53.6363 263.842 65.6504 270.778 77.3386 267.646L236.891 224.894C248.579 221.762 255.516 209.748 252.384 198.06C249.252 186.372 237.238 179.436 225.55 182.568Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228.529 91.7593C240.677 91.7593 250.526 81.911 250.526 69.7625C250.526 57.614 240.677 47.7656 228.529 47.7656C216.38 47.7656 206.532 57.614 206.532 69.7625C206.532 81.911 216.38 91.7593 228.529 91.7593Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRightGraphic);
export default __webpack_public_path__ + "static/media/topRightGraphic.66e779f8e04d1fb305fc675afd6abb04.svg";
export { ForwardRef as ReactComponent };